<template lang="html">
  <div class="expandable" :class="{expanded: open}">
    <div ref='content' class="expandable-content">
      <slot></slot>
    </div>

    <div class="expandable-btn">
      <a href="#" @click.prevent="expand" aria-label="Expand content">
      <span class="fa fa-angle-down"></span></a>
    </div>
  </div>
</template>

<script>
export default {
  name: "expandable",

  props: {},

  mounted: function() {
    if (this.$refs.content.scrollHeight - this.$el.scrollHeight < 150) {
      this.open = true;
    }
  },

  data: function() {
    return {
      open: false
    };
  },

  methods: {
    expand: function() {
      this.open = true;
    }
  }
};
</script>

<style lang="css">
</style>
